import { useSuspenseQuery } from "@tanstack/react-query";
import { myAccountApi } from "@/features/my-account/api";
import { FavSku } from "@/features/my-account/types";

const useGetFavSkus = (buyer_id?: number) => {
  const { data: favSku } = useSuspenseQuery<FavSku>({
    queryKey: ["my-account", "favSkus", buyer_id],
    queryFn: () => {
      if (buyer_id == null) {
        // buyer_id 없으면 빈 리스트 바로 리턴
        return { skus: [] };
      }
      return myAccountApi.getFavSkus(buyer_id);
    },
  });
  return { favSkus: favSku.skus };
};

export default useGetFavSkus;
